<template>
  <div class="text-center con__dialog">
    <v-dialog
      v-model="dialog_form"
      width="400"
      persistent
      overlay-opacity="0.8"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card width="400" height="200" class="pa-6 form__dialog">
          <div>
            <div class="dialog__header text-center font-suk-b mb-6 mt-5">
              ยืนยันการแก้ไขข้อมูลหรือไม่?
            </div>
          </div>

          <div class="pb-4">
            <v-row justify="space-between">
              <v-col cols="6">
                <v-btn
                  block
                  color="var(--theme-color-one)"
                  outlined
                  height="40"
                  text
                  @click="dialog_form = false"
                  style="border-radius: 8px;border-color: var(--theme-color-one);"
                >
                  ยกเลิก
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  block
                  :disabled="!valid"
                  :dark="valid"
                  color="var(--theme-color-one)"
                  class="mr-4"
                  height="40"
                  @click="validate"
                  style="border-radius: 8px"
                  depressed
                >
                  ยืนยัน
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="dialog_success"
      width="400"
      persistent
      overlay-opacity="0.8"
    >
      <v-card width="400" flat class="pa-6" style="border-radius: 12px">
        <v-layout justify-center mt-2>
          <v-flex shrink>
            <v-img
              width="70"
              height="70"
              aspect-ratio="1"
              :src="require('../assets/img/icon-dialog-success.png')"
            ></v-img>
          </v-flex>
        </v-layout>

        <div class="dialog__header text-center font-suk-b mb-4 mt-7">
          แก้ไขข้อมูลสำเร็จ
        </div>

        <v-btn
          @click="dialog_success = false; reloadPage()"
          style="border-radius: 8px"
          block
          dark
          color="var(--theme-color-one)"
        >
          ตกลง
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { controllerName } from "@/store/constants";

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: "",
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    itemId: null,
  },
  data() {
    return {
      valid: true,
      dialog_success: false,
      form: {
        itemId: this.itemId,
      },
    };
  },
  computed: {
    dialog_form: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit("update:isOpen", value);
      },
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
          this.$emit("update:isOpen", false);
          this.$emit("onConfirm");
          this.$emit("onClose");
          this.dialog_success = true;
      }
    },
    reloadPage() {
      window.location.reload();
    }
  },
};
</script>

<style lang="scss">
.con__dialog {
  font-family: SukhumvitM;
}
.dialog__header {
  font-size: 20px !important;
  font-weight: 700;
}
.form__dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
